<script>
    import { onMount, beforeUpdate, createEventDispatcher } from 'svelte'
    // import { Link, navigate } from 'svelte-routing'
    import { Link, navigateTo } from 'yrv';
    import axios from 'axios'
    import Modal from '../../components/Modal/Modal.svelte'
    import SimpleFormField from '../../components/SimpleFormField/SimpleFormField.svelte'
    import TouchButton from '../../components/TouchButton/TouchButton.svelte'
    import FadeinFX from '../../components/FX/FadeinFx.svelte'

    
    let busy        = false,
        error       = false,
        success     = false,
        errorText   = '',
        formState   = {
            username: '',
            password: ''
        }


    $: {
        if (error) {
            document.body.classList.add ('login-error')
        } else {
            document.body.classList.remove ('login-error')
        }
    }

    const dispatch = createEventDispatcher ();

    const onFieldChange = (o) => {
        formState[o.detail.name] = o.detail.value;
    }

    const doLogin = () => {
        if (formState.username !== '' && formState.password !== '') {
            error = false;
            busy = true;
            axios.post ('/api/jwtlogin/authorize', formState).then (result => {
                setTimeout (() => {
                    success = true;
                    busy = false;
                    setTimeout (() => {
                        document.body.classList.remove ('login-body');
                        dispatch ('app-event', { id: 'login', value: true });
                        navigateTo ('/app')
                    }, 500)
                }, 500)
            }).catch (e => {
                busy = false
                error = true;
                errorText = 'Invalid login, please retry.'
            })
        } else {
            error = true;
            errorText = 'Invalid username/password'
        }
    }

    onMount (() => {
        document.body.classList.remove ('white-bg')
        document.body.classList.add ('login-body')
    })
</script>


<div class="Login">
    <div class="login-holder" class:success>
        <div class="login-logo-placeholder">
            <div class="login-logo fx animated" class:busy>
                {#if (busy)}
                    <div class="busy-icn animated">
                        <i class="fad fa-spinner-third fa-spin"></i>
                    </div>
                {:else}
                    <i class="fad fa-vacuum"></i>
                {/if}
            </div>
        </div>
        <FadeinFX delay={300}>
            <div class="login-form">
                <!-- /*  fx animated softFadeInUp */ -->
                <div class="message">
                    {error ? errorText : 'Welcome'}
                </div>
                <SimpleFormField type="text" name="username" placeholder="Username" on:fieldchange={onFieldChange}/>
                <SimpleFormField type="password" name="password" placeholder="Password" on:fieldchange={onFieldChange}/>
                <div class="ctrls">
                    <TouchButton click={doLogin}>Login</TouchButton>
                    <!-- <button class="btn btn-primary" on:click={doLogin}>Login</button> -->
                </div>
            </div>
        </FadeinFX>
    </div>
</div>



<style>
    .Login {
        position: fixed;
        width: 280px;
        text-align: center;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .Login :global(.login-holder) {
        -webkit-transition: all 0.3s;
        -moz-transition: all 0.3s;
        transition: all 0.3s;
    }
    .Login :global(.login-holder.success) {
        -webkit-transform: scale(2);
        -moz-transform: scale(2);
        -ms-transform: scale(2);
        transform: scale(2);
        opacity: 0;
    }

    .Login :global(.fx), .Login :global(.busy-icn) {
        -webkit-animation-duration: .4s;
        animation-duration: .4s;
    }

    .Login .ctrls {
        margin-top: 10px;
    }
    .Login .ctrls :global(.btn) {
        width: 100%;
        background-color: #fff;
        color: #1c85d6;
        font-weight: 600;
        border: none;
    }

    .Login .login-form {
        -webkit-animation-delay: .3s;
        animation-delay: .3s;
    }

    .Login .login-form .message {
        font-weight: 600;
        color: #fff;
    }

    .Login .login-logo-placeholder {
        height: 150px;
        margin-bottom: 20px;
    }
    .Login .login-logo {
        display: inline-block;
        background-color: #fff;
        width: 150px;
        height: 150px;
        line-height: 150px;
        /* border-radius: 50%; */
        border-radius: 14px;
        text-align: center;
        font-size: 70px;
        color: #1c85d6;
        -webkit-animation-name: popIn;
        animation-name: popIn;
    }
    .Login .login-logo.busy {
        background: none;
        color: #fff;
        -webkit-animation-name: softZoomIn;
        animation-name: softZoomIn;
        /* -webkit-animation-delay: .5s;
        animation-delay: .5s; */
    }
    

    :global(.login-body) :global(.simple-form-field) :global(input) {
        width: 100%;
        background: none;
        border-bottom-color: rgba(255, 255, 255, .6);
        color: #fff;
        font-weight: 600;
    }

    :global(.login-body) :global(.simple-form-field) :global(input:focus) {
        border-bottom-color: #fff;
    }

    :global(.login-body) :global(::-webkit-input-placeholder) {
        color: rgba(255, 255, 255, .7);
    }
</style>